import moment from "moment";
import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { toast } from "react-toastify";

const MessagingUsersTable = (props) => {
  const [activeIndex, setActiveIndex] = useState(null);
  const { users, getAllUsers } = props;

  const filteredAndSortedUsers = users
    .filter((user) => user.isMessaging)
    .sort((a, b) => b.watchedStories.length - a.watchedStories.length);

  const handleIconClick = (index) => {
    if (index === activeIndex) {
      setActiveIndex(null);
    } else {
      setActiveIndex(index);
    }
  };

  const deleteUser = async (id) => {
    if (window.confirm("Are you sure ? You want to delete this user!")) {
      try {
        const response = null;
        if (response) {
          toast.success("Delete user successfully!");
          getAllUsers();
        }
      } catch (error) {
        toast.error(error);
      }
    }
  };

  return (
    <table>
      <thead>
        <tr>
          <th className="users-th">Id</th>
          <th className="users-th">Phone Number</th>
          <th className="users-th" style={{ width: "109px" }}>
            Completed stories
          </th>
          <th className="users-th">Mentor Admin</th>
          <th className="users-th">Gender</th>
          <th className="users-th">Age Group</th>
          <th className="users-th">City/Region</th>
          <th className="users-th">country</th>
          <th className="users-th">Last message date</th>
          <th className="users-th">Last Date Active</th>
          <th className="users-th">Signup Date</th>
          <th className="users-th">Action</th>
        </tr>
      </thead>
      <tbody>
        {filteredAndSortedUsers.map((user, index) => (
          <tr>
            <td className="users-td" key={index}>
              {user._id}
            </td>
            <td className="users-td">
              <div>{user.phoneNumber}</div>
            </td>
            <td className="users-td">{user.watchedStories.length}</td>
            <td className="users-td">{user.nameOfMentor}</td>
            <td className="users-td">{user.gender}</td>
            <td className="users-td">{user.ageGroup}</td>
            <td className="users-td">{user.city}</td>
            <td className="users-td">{user.country}</td>
            <td className="users-td">{user.lastMsgOn}</td>
            <td className="users-td">10-Jan-2003</td>
            <td className="users-td">
              {moment(user.createdAt).format("DD-MMM-YYYY")}
            </td>
            <td className="users-td">
              <ion-icon
                name="ellipsis-vertical-outline"
                id="userAction"
                onClick={() => handleIconClick(index)}
                style={{ cursor: "pointer" }}
              ></ion-icon>
              {activeIndex === index && (
                <div className="showOption setPopup">
                  <NavLink
                    to={`/view-user/${user._id}`}
                    style={{ textDecoration: "none" }}
                  >
                    <p className="pt-3 d-flex align-items-center gap-2">
                      <ion-icon name="eye-outline"></ion-icon> View
                    </p>
                  </NavLink>
                  <p
                    className="d-flex align-items-center gap-2"
                    style={{ color: "red", cursor: "pointer" }}
                    onClick={() => deleteUser(user._id)}
                  >
                    <ion-icon name="trash-outline"></ion-icon> Delete
                  </p>
                  {/* <p className="d-flex align-items-center gap-2">
                    <ion-icon name="ban-outline"></ion-icon>Deactivate
                  </p> */}
                </div>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default MessagingUsersTable;
